import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from "./Entities/Home";
import { Nefrosys } from "./Entities/pages/Nefrosys";
import { UNEFRO } from "./Entities/pages/UNEFRO";
import { CitaConfirmada } from "./Entities/CitaConfirmada";
import { Consulta } from "./Entities/Consulta";
import { App as AppProd } from "./Entities/App";
import { Inicio } from "./Entities/Inicio";
import "rsuite/dist/rsuite.min.css";
import '@coreui/coreui/dist/css/coreui.min.css'
import "./App.css";
import { Pacientes } from "./Entities/Pacientes";
import { Citas } from "./Entities/Citas";
import { CitasMedicas } from "./Entities/CitasMedicas";
import { Horarios } from "./Entities/Horarios";
import { InicioHemodialisis } from "./Entities/InicioHemodialisis";
import { AsignaFiltro } from "./Entities/AsignaFiltro";
import { Inventario } from "./Entities/Inventario";
import { Insumos } from "./Entities/Insumos";
import { Enfermeria } from "./Entities/Enfermeria";
import { MaquinasDialisis } from "./Entities/MaquinasDialisis";
import { Medicos } from "./Entities/Medicos";
import { Tecnicos } from "./Entities/Tecnicos";
import { Servicios } from "./Entities/Servicios";
import { Usuarios } from "./Entities/Usuarios";
import { HojaEnfermeria } from "./Entities/HojaEnfermeria/HojaEnfermeria";
import { AccesoModulo } from "./Entities/AccesoModulo";
import {NotaMedica} from "./Entities/NotaMedica";
import { HojaEnfermeriaView } from "./Entities/HojaEnfermeria/HojaEnfermeriaView";
import { NotaMedicaView } from "./Entities/NotaMedicaView";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" Component={Nefrosys} />
        <Route path="/App/Home" Component={Home} />
        <Route path="/App/Home/AccesoModulo" Component={AccesoModulo} />
        <Route path="/App/Home/Citas" Component={Citas} />
        <Route path="/App/Home/CitasMedicas" Component={CitasMedicas} />
        <Route path="/App/Home/CitasMedicas/Consulta/:idPaciente/:idServicio/:fecha/:hora" Component={Consulta} />
        <Route path="/App/Home/Pacientes" Component={Pacientes} />
        <Route path="/App/Home/AsignaFiltro" Component={AsignaFiltro} />
        <Route path="/App/Home/Consulta" Component={Consulta} />
        <Route path="/App/Home/Medicos" Component={Medicos} />
        <Route path="/App/Home/Horarios" Component={Horarios} />
        <Route path="/App/Home/Insumos" Component={Insumos} />
        <Route path="/App/Home/Servicios" Component={Servicios} />
        <Route path="/App/Home/Enfermeria" Component={Enfermeria} />
        <Route path="/App/Home/Tecnicos" Component={Tecnicos} />
        <Route path="/App/Home/Usuarios" Component={Usuarios} />
        <Route path="/App/Home/MaquinasDialisis" Component={MaquinasDialisis} />
        <Route path="/App/Home/InicioHemodialisis" Component={InicioHemodialisis} />
        <Route path="/App/Home/HojaEnfermeria" Component={HojaEnfermeria} />
        <Route path="/App/Home/HojaEnfermeriaView/:idSesion/:idPaciente" Component={HojaEnfermeriaView} />
        <Route path="/App/Home/Inventario" Component={Inventario} />
        <Route path="/App" Component={AppProd} />
        <Route path="/App/Inicio" Component={Inicio} />
        <Route path="/App/Inicio/Consulta" Component={Consulta} />
        <Route path="/UNEFRO" Component={UNEFRO} />
        <Route path="/CitaConfirmada/:id/:phone" Component={CitaConfirmada} />
        <Route path="/App/Home/NotaMedica" Component={NotaMedica} />
        <Route path="/App/Home/NotaMedicaView/:idSesion/:idPaciente" Component={NotaMedicaView} />
      </Routes>
    </Router>
  );
}

export default App;
